// Libs
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import Input from '../../../Field/Input';
import FooterButtons from '../../../Modal/FooterButtons';

// Actions
import { CleanSharedKitActionError } from '../../../../actions/sharedKits';

// Constants
import {
  attendeeCountLabel,
  invalidAttendeeCountMessage,
} from '../../../../constants/sharedKits';

const AttendeeCountModal = ({ onClickSave, onClickCancel }) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState('');
  const [localError, setLocalError] = useState('');
  const actionError = useSelector((state) => state.sharedKits?.actionError);

  useEffect(() => {
    return () => dispatch(CleanSharedKitActionError());
  }, [dispatch]);

  const onSave = () => {
    const attendeeCount = Number(value);

    if (!Number.isInteger(attendeeCount) || attendeeCount < 1) {
      setLocalError(invalidAttendeeCountMessage);
      return;
    }

    setLocalError('');
    onClickSave(attendeeCount);
  };

  return (
    <>
      <Input
        id="attendee-count-input"
        onChange={({ value: newValue }) => {
          setLocalError('');
          setValue(newValue.replace(/\D/g, ''));
        }}
        value={value}
        maxLength={6}
        label={attendeeCountLabel}
        error={localError || actionError}
        required
        data-testid="attendee-count-modal-input"
      />
      <FooterButtons
        onReject={onClickCancel}
        acceptTitle="Submit"
        rejectTitle="Cancel"
        onAccept={onSave}
        disabledAcceptBtn={!value}
      />
    </>
  );
};

export default AttendeeCountModal;
